// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__NiLhN"};